<table mat-table matSort class="w-full" [dataSource]="tableData">
  @for (column of TABLE_COLUMNS; track trackByProperty($index, column)) {
    <!-- Text Columns -->
    @if (column.type === 'text') {
      <ng-container
        [matColumnDef]="column.property"
        >
        <th
          *matHeaderCellDef
          class="uppercase"
          mat-header-cell
          [mat-sort-header]="column.property"
          >
          {{ column.label }}
        </th>
        <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>
          @switch (column.property) {
            @case ('place') {
              <div>
                {{ getTranslation(row).cityName }}
              </div>
            }
            @default {
              <div>{{ row[column.property] }}</div>
            }
          }
        </td>
      </ng-container>
    }
  }
  <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
  <tr
    *matRowDef="let row; columns: visibleColumns"
    @fadeInUp
    class="cursor-pointer hover:bg-hover trans-ease-out"
    mat-row
  ></tr>
</table>
<mat-paginator
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSize"
  class="sticky left-0"
></mat-paginator>
